export default __webpack_public_path__ + "static/media/app.9b960ad5.jpg";